import { useMutation, useQueryClient } from "@tanstack/react-query";
import { RequestRuleResponse, UpdateRuleDTO } from "@/types";
import { httpRequest } from "@/lib";

async function updateRule(
  request: UpdateRuleDTO
): Promise<RequestRuleResponse> {
  const { id, ...data } = request;
  const response = await httpRequest.put<RequestRuleResponse>(
    `/roles/${id}`,
    data
  );
  return response.data;
}

export function useUpdateRuleMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateRule,
    onSuccess: () => {
      return queryClient.invalidateQueries({ queryKey: ["roles"] });
    },
  });
}
